import React from 'react';

export default function LotDetails({ lot }) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200 bg-gray-50">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Physical Details</h3>
      </div>
      <dl className="divide-y divide-gray-200">
        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Metal</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">{lot.metal || '—'}</dd>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Composition</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">{lot.composition ? `${lot.composition}%` : '—'}</dd>
        </div>
        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Weight</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">{lot.weight ? `${lot.weight}g` : '—'}</dd>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Diameter</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">{lot.diameter ? `${lot.diameter}mm` : '—'}</dd>
        </div>
        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Edge</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">{lot.edge || '—'}</dd>
        </div>
      </dl>
    </div>
  );
}
